import React from 'react';
import Countdown, { zeroPad } from 'react-countdown-now';
import TimeSync from 'utils/TimeSync';
import './NotificationCountdown.css';

export default function NotificationCountdown({
  text,
  time,
  onClose,
  notificationId
}) {
  const renderer = ({ minutes, seconds }) => {
    let countdown = `${zeroPad(minutes)}:${zeroPad(seconds)}`;
    return (
      <div className="notification-countdown-text">
        <span>{text}</span>
        <span className="highlight notranslate">{countdown}</span>
      </div>
    );
  };

  return (
    <Countdown
      date={TimeSync.toLocalTime(time)}
      renderer={renderer}
      onComplete={() => {
        onClose(notificationId);
      }}
    />
  );
}
